<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <path
      d="M4.666 6.332c0-.921.746-1.667 1.667-1.667H10a1 1 0 1 0 0-2H6.333a3.666 3.666 0 0 0-3.667 3.667v11.333a3.666 3.666 0 0 0 3.667 3.667h11.333a3.666 3.666 0 0 0 3.667-3.667V14a1 1 0 1 0-2 0v3.666c0 .921-.746 1.667-1.667 1.667H6.333a1.666 1.666 0 0 1-1.667-1.667V6.332Z"
      fill="currentColor" /><path
      d="M21.047 2.965a.997.997 0 0 1 .286.7V10a1 1 0 0 1-2 0V6.08l-6.626 6.627a1 1 0 0 1-1.414-1.414l6.626-6.627h-3.92a1 1 0 1 1 0-2h6.334c.273 0 .52.11.7.287l.014.013Z"
      fill="currentColor" />
  </g>
</svg>
